import * as React from 'react';

import { MoreHorizontal } from 'lucide-react';
import { cva, VariantProps } from 'class-variance-authority';
import { OmitStylesComponentProps } from '../../types';

const paginationEllipsisVariants = cva('rocco-pagination-ellipsis', {
    variants: {
        variant: {
            default: 'flex h-9 w-9 items-center justify-center',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const PaginationEllipsis = ({
    variant,
    ...props
}: OmitStylesComponentProps<'span'> &
    VariantProps<typeof paginationEllipsisVariants>) => (
    <span
        aria-hidden
        className={paginationEllipsisVariants({ variant })}
        {...props}
    >
        <MoreHorizontal className="h-4 w-4" />
        <span className="sr-only">More pages</span>
    </span>
);

PaginationEllipsis.displayName = 'PaginationEllipsis';
